import { FC } from 'react';
import security from 'stores/security';
import './style.scss';

const Header: FC = () => {
    const isIRA = security.isIRAAccount;

    return (
        <div className="funding-records-header">
            <h2 className="title">{__('Funds Transfer History')}</h2>
            <p className="desc">
                {isIRA
                    ? __('Please note there may be a delay in showing your transfers in progress')
                    : __('*Please notice there might be a delay in showing your new deposit')}
            </p>
        </div>
    );
};

export default Header;
